export enum EditFormKeys {
    Title = 'title',
    Description = 'description',
    Code = 'code',
    Sort = 'sort',
    Active = 'active',
    Users = 'users',
}
